
import React from "react";
import bowl from "../../media/bowl_homepage.png"
import basket from "../../media/basket_homepage.png"

const categories = [
    {
      id: 1,
      title: "Jute Baskets",
      description: "Discover our handwoven jute baskets — perfect for home organization, decor, and theme-based functions. Stylish, sustainable, and practical.",
      image: basket,
      url: "/categories/jute-baskets"
    },
    {
      id: 2,
      title: "Jute Bowls",
      description: "Beautifully crafted jute bowls designed for elegant and eco-friendly serving or decor. A natural addition to your kitchen and table setup.",
      image: bowl,
      url: "/categories/table-coaster"
    },
    {
      id: 3,
      title: "Jute Storage Organizer",
      description: "Organize your space naturally with our handcrafted jute storage organizers — ideal for storing clothes, toys, books, and more while adding a rustic charm to any room",
      image: "http://res.cloudinary.com/dn6mtzcht/image/upload/v1747918267/ujnkuktky1dq5vqgq4t5.jpg",
      url: "/categories/jute-rugs"
    },
    {
      id: 4,
      title: "Jute Bags",
      description: "Eco-friendly jute bags designed for style and sustainability — perfect for daily use, shopping, or casual outings.",
      image: "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057212/hd8pyvvhuahbyry0sd53.jpg",
      url: "/categories/bath-mat"
    }
  ];
  

const ProductCategoriesGrid = () => {
  return (
    <section className="py-16 px-4 bg-[#F0EAE0]">
      <div className="max-w-6xl mx-auto">


        <div className="mb-20 text-center">
            <h2 className="heading-md mb-3">Our Categories</h2>
            <p className="max-w-2xl mx-auto text-muted-foreground">
                Our collection of handcrafted jute products, each designed to bring natural elegance to your home.
            </p>
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
          {categories.map((category, index) => (
            <div
              key={category.id}
              className={`relative ${index % 2 === 0 ? 'md:-translate-y-8' : 'md:translate-y-8'}`}
            >
              {/* Vertical Line Design Element */}
              <div className="absolute left-4 top-4 w-0.5 h-12 bg-amber-600 z-10"></div>
              
              {/* Image Container */}
              <div className="relative overflow-hidden rounded-lg mb-6 group">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
              </div>
              
              {/* Content Section with Left Padding */}
              <div className="pl-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  {category.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed line-height-6">
                  {category.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategoriesGrid;